// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-page {
  max-width: 1400px;
  margin: 0 auto;
}

.admin-page h1 {
  margin-bottom: 30px;
  color: #333;
}

.email-config-section,
.backup-section,
.reminders-section,
.pto-management-section {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 30px;
}

.email-config-section h2,
.backup-section h2,
.reminders-section h2,
.pto-management-section h2 {
  margin-bottom: 10px;
  color: #333;
}

.reminders-section h2 {
  margin-bottom: 10px;
  color: #333;
}

.subtitle {
  color: #666;
  margin-bottom: 30px;
}

.reminders-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.reminder-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  background: #fafafa;
}

.reminder-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.reminder-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 24px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

.toggle-switch input:checked + .toggle-slider {
  background-color: #1976d2;
}

.toggle-switch input:checked + .toggle-slider:before {
  transform: translateX(26px);
}

.reminder-description {
  color: #666;
  margin-bottom: 15px;
  font-size: 14px;
}

.reminder-schedule {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 15px;
}

.reminder-schedule label {
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

.schedule-select {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background: white;
  font-size: 14px;
}

.schedule-inputs {
  display: flex;
  gap: 10px;
}

.schedule-inputs .schedule-select {
  flex: 2 1;
}

.schedule-inputs .schedule-time {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background: white;
  font-size: 14px;
  font-family: inherit;
}

.trigger-button {
  width: 100%;
  padding: 10px;
  background: #1976d2;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.3s;
  margin-bottom: 10px;
}

.trigger-button:hover {
  background: #1565c0;
}

.last-triggered {
  font-size: 12px;
  color: #666;
  text-align: center;
  margin: 0;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #666;
}

.email-config-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-group input,
.form-group select {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
  font-family: inherit;
  transition: border-color 0.3s;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #1976d2;
}

.form-group small {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}

.checkbox-group {
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.checkbox-group input[type="checkbox"] {
  width: auto;
  margin: 0;
}

.checkbox-group span {
  font-weight: normal;
}

.form-actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.btn-primary,
.btn-secondary {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s;
}

.btn-primary {
  background: #1976d2;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: #1565c0;
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-secondary {
  background: white;
  color: #1976d2;
  border: 1px solid #1976d2;
}

.btn-secondary:hover:not(:disabled) {
  background: #f5f5f5;
}

.btn-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.backup-config-section {
  margin-bottom: 30px;
  padding: 20px;
  background: #f9f9f9;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
}

.backup-config-section h3 {
  margin-top: 0;
  margin-bottom: 20px;
  color: #333;
  font-size: 18px;
}

.schedule-selector {
  background: white;
  padding: 20px;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  margin-bottom: 20px;
}

.schedule-selector h4 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #333;
  font-size: 16px;
}

.time-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.time-input-group select {
  flex: 1 1;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
}

.time-input-group span {
  font-weight: 600;
  color: #666;
}

.schedule-preview {
  margin-top: 15px;
  padding: 10px;
  background: #e3f2fd;
  border-radius: 4px;
  color: #1976d2;
  font-size: 13px;
  font-family: monospace;
}

.backup-config-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.backup-last-run {
  padding: 10px;
  background: #e3f2fd;
  border-radius: 4px;
  color: #1976d2;
  font-size: 14px;
}

.backup-actions {
  margin-bottom: 30px;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 5px;
}

.backup-action-buttons {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
}


.backup-info {
  margin-top: 10px;
  font-size: 14px;
  color: #666;
}

.backups-list {
  margin-top: 20px;
}

.backups-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.backups-table th {
  background: #f5f5f5;
  padding: 12px;
  text-align: left;
  font-weight: 600;
  border-bottom: 2px solid #ddd;
  color: #333;
}

.backups-table td {
  padding: 12px;
  border-bottom: 1px solid #eee;
}

.backups-table tbody tr:hover {
  background: #f9f9f9;
}

.backup-actions-cell {
  display: flex;
  gap: 10px;
}

.btn-download,
.btn-delete,
.btn-restore,
.btn-send-email {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.btn-restore {
  background: #2196F3;
  color: white;
}

.btn-restore:hover {
  background: #0b7dda;
}

.btn-download {
  background: #4caf50;
  color: white;
}

.btn-download:hover {
  background: #45a049;
}

.btn-send-email {
  background: #ff9800;
  color: white;
}

.btn-send-email:hover {
  background: #f57c00;
}

.btn-delete {
  background: #f44336;
  color: white;
}

.btn-delete:hover {
  background: #da190b;
}

.no-backups {
  text-align: center;
  padding: 40px;
  color: #666;
  font-style: italic;
}

/* PTO Management Styles */
.pto-table-wrapper {
  overflow-x: auto;
}

.pto-admin-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
}

.pto-admin-table thead {
  background: #f5f5f5;
}

.pto-admin-table th,
.pto-admin-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.pto-admin-table th {
  font-weight: 600;
  color: #333;
}

.pto-admin-table tbody tr:hover {
  background: #fafafa;
}

.pto-type-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
}

.pto-type-badge.vacation {
  background: #e3f2fd;
  color: #1976d2;
}

.pto-type-badge.sick {
  background: #ffebee;
  color: #c62828;
}

.pto-type-badge.personal {
  background: #f3e5f5;
  color: #7b1fa2;
}

.pto-type-badge.other {
  background: #fff3e0;
  color: #e65100;
}

.pto-status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
}

.pto-status-badge.pending {
  background: #fff3e0;
  color: #e65100;
}

.pto-status-badge.approved {
  background: #e8f5e9;
  color: #2e7d32;
}

.pto-status-badge.rejected {
  background: #ffebee;
  color: #c62828;
}

.pto-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.btn-approve {
  padding: 6px 12px;
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.3s;
}

.btn-approve:hover {
  background: #45a049;
}

.btn-reject {
  padding: 6px 12px;
  background: #f44336;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.3s;
}

.btn-reject:hover {
  background: #da190b;
}

.btn-delete-small {
  padding: 4px 8px;
  background: #757575;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: background 0.3s;
}

.btn-delete-small:hover {
  background: #616161;
}

@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
  }
  
  .backups-table {
    font-size: 12px;
  }
  
  .backup-actions-cell {
    flex-direction: column;
    gap: 5px;
  }
  
  .pto-admin-table {
    font-size: 12px;
  }
  
  .pto-admin-table th,
  .pto-admin-table td {
    padding: 8px;
  }
}

/* Send Backup Email Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content.send-email-modal {
  background: white;
  border-radius: 8px;
  max-width: 440px;
  width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.send-email-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e0e0e0;
}

.send-email-modal .modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.send-email-modal .modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  line-height: 1;
  padding: 0 4px;
}

.send-email-modal .modal-close:hover {
  color: #333;
}

.send-email-modal .modal-body {
  padding: 20px;
}

.send-email-modal .send-email-file-name {
  margin: 0 0 16px;
  font-size: 14px;
  color: #666;
}

.send-email-modal .form-group {
  margin-bottom: 12px;
}

.send-email-modal .form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  font-size: 14px;
  color: #333;
}

.send-email-modal .form-group input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.send-email-modal .send-email-note {
  margin: 12px 0 0;
  font-size: 12px;
  color: #666;
}

.send-email-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 20px;
  border-top: 1px solid #e0e0e0;
  background: #f9f9f9;
  border-radius: 0 0 8px 8px;
}

`, "",{"version":3,"sources":["webpack://./src/pages/Admin.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;;EAIE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;;;;EAIE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;;AAGA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;;EAIE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;AACF;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,0BAA0B;AAC5B","sourcesContent":[".admin-page {\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.admin-page h1 {\n  margin-bottom: 30px;\n  color: #333;\n}\n\n.email-config-section,\n.backup-section,\n.reminders-section,\n.pto-management-section {\n  background: white;\n  padding: 30px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  margin-bottom: 30px;\n}\n\n.email-config-section h2,\n.backup-section h2,\n.reminders-section h2,\n.pto-management-section h2 {\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.reminders-section h2 {\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.subtitle {\n  color: #666;\n  margin-bottom: 30px;\n}\n\n.reminders-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.reminder-card {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 20px;\n  background: #fafafa;\n}\n\n.reminder-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.reminder-header h3 {\n  margin: 0;\n  color: #333;\n  font-size: 18px;\n}\n\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 24px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.4s;\n  border-radius: 24px;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n\n.toggle-switch input:checked + .toggle-slider {\n  background-color: #1976d2;\n}\n\n.toggle-switch input:checked + .toggle-slider:before {\n  transform: translateX(26px);\n}\n\n.reminder-description {\n  color: #666;\n  margin-bottom: 15px;\n  font-size: 14px;\n}\n\n.reminder-schedule {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 15px;\n}\n\n.reminder-schedule label {\n  font-size: 12px;\n  color: #666;\n  font-weight: 500;\n}\n\n.schedule-select {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  background: white;\n  font-size: 14px;\n}\n\n.schedule-inputs {\n  display: flex;\n  gap: 10px;\n}\n\n.schedule-inputs .schedule-select {\n  flex: 2;\n}\n\n.schedule-inputs .schedule-time {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  background: white;\n  font-size: 14px;\n  font-family: inherit;\n}\n\n.trigger-button {\n  width: 100%;\n  padding: 10px;\n  background: #1976d2;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background 0.3s;\n  margin-bottom: 10px;\n}\n\n.trigger-button:hover {\n  background: #1565c0;\n}\n\n.last-triggered {\n  font-size: 12px;\n  color: #666;\n  text-align: center;\n  margin: 0;\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n.email-config-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  font-weight: 500;\n  color: #333;\n  font-size: 14px;\n}\n\n.form-group input,\n.form-group select {\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 14px;\n  font-family: inherit;\n  transition: border-color 0.3s;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #1976d2;\n}\n\n.form-group small {\n  font-size: 12px;\n  color: #666;\n  margin-top: 4px;\n}\n\n.checkbox-group {\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n  width: auto;\n  margin: 0;\n}\n\n.checkbox-group span {\n  font-weight: normal;\n}\n\n.form-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.btn-primary,\n.btn-secondary {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: all 0.3s;\n}\n\n.btn-primary {\n  background: #1976d2;\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: #1565c0;\n}\n\n.btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-secondary {\n  background: white;\n  color: #1976d2;\n  border: 1px solid #1976d2;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: #f5f5f5;\n}\n\n.btn-secondary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.backup-config-section {\n  margin-bottom: 30px;\n  padding: 20px;\n  background: #f9f9f9;\n  border-radius: 5px;\n  border: 1px solid #e0e0e0;\n}\n\n.backup-config-section h3 {\n  margin-top: 0;\n  margin-bottom: 20px;\n  color: #333;\n  font-size: 18px;\n}\n\n.schedule-selector {\n  background: white;\n  padding: 20px;\n  border-radius: 5px;\n  border: 1px solid #e0e0e0;\n  margin-bottom: 20px;\n}\n\n.schedule-selector h4 {\n  margin-top: 0;\n  margin-bottom: 15px;\n  color: #333;\n  font-size: 16px;\n}\n\n.time-input-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.time-input-group select {\n  flex: 1;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 14px;\n}\n\n.time-input-group span {\n  font-weight: 600;\n  color: #666;\n}\n\n.schedule-preview {\n  margin-top: 15px;\n  padding: 10px;\n  background: #e3f2fd;\n  border-radius: 4px;\n  color: #1976d2;\n  font-size: 13px;\n  font-family: monospace;\n}\n\n.backup-config-form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.backup-last-run {\n  padding: 10px;\n  background: #e3f2fd;\n  border-radius: 4px;\n  color: #1976d2;\n  font-size: 14px;\n}\n\n.backup-actions {\n  margin-bottom: 30px;\n  padding: 20px;\n  background: #f5f5f5;\n  border-radius: 5px;\n}\n\n.backup-action-buttons {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n\n.backup-info {\n  margin-top: 10px;\n  font-size: 14px;\n  color: #666;\n}\n\n.backups-list {\n  margin-top: 20px;\n}\n\n.backups-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\n.backups-table th {\n  background: #f5f5f5;\n  padding: 12px;\n  text-align: left;\n  font-weight: 600;\n  border-bottom: 2px solid #ddd;\n  color: #333;\n}\n\n.backups-table td {\n  padding: 12px;\n  border-bottom: 1px solid #eee;\n}\n\n.backups-table tbody tr:hover {\n  background: #f9f9f9;\n}\n\n.backup-actions-cell {\n  display: flex;\n  gap: 10px;\n}\n\n.btn-download,\n.btn-delete,\n.btn-restore,\n.btn-send-email {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.3s;\n}\n\n.btn-restore {\n  background: #2196F3;\n  color: white;\n}\n\n.btn-restore:hover {\n  background: #0b7dda;\n}\n\n.btn-download {\n  background: #4caf50;\n  color: white;\n}\n\n.btn-download:hover {\n  background: #45a049;\n}\n\n.btn-send-email {\n  background: #ff9800;\n  color: white;\n}\n\n.btn-send-email:hover {\n  background: #f57c00;\n}\n\n.btn-delete {\n  background: #f44336;\n  color: white;\n}\n\n.btn-delete:hover {\n  background: #da190b;\n}\n\n.no-backups {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n  font-style: italic;\n}\n\n/* PTO Management Styles */\n.pto-table-wrapper {\n  overflow-x: auto;\n}\n\n.pto-admin-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.pto-admin-table thead {\n  background: #f5f5f5;\n}\n\n.pto-admin-table th,\n.pto-admin-table td {\n  padding: 12px 15px;\n  text-align: left;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.pto-admin-table th {\n  font-weight: 600;\n  color: #333;\n}\n\n.pto-admin-table tbody tr:hover {\n  background: #fafafa;\n}\n\n.pto-type-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.pto-type-badge.vacation {\n  background: #e3f2fd;\n  color: #1976d2;\n}\n\n.pto-type-badge.sick {\n  background: #ffebee;\n  color: #c62828;\n}\n\n.pto-type-badge.personal {\n  background: #f3e5f5;\n  color: #7b1fa2;\n}\n\n.pto-type-badge.other {\n  background: #fff3e0;\n  color: #e65100;\n}\n\n.pto-status-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.pto-status-badge.pending {\n  background: #fff3e0;\n  color: #e65100;\n}\n\n.pto-status-badge.approved {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.pto-status-badge.rejected {\n  background: #ffebee;\n  color: #c62828;\n}\n\n.pto-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.btn-approve {\n  padding: 6px 12px;\n  background: #4caf50;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background 0.3s;\n}\n\n.btn-approve:hover {\n  background: #45a049;\n}\n\n.btn-reject {\n  padding: 6px 12px;\n  background: #f44336;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background 0.3s;\n}\n\n.btn-reject:hover {\n  background: #da190b;\n}\n\n.btn-delete-small {\n  padding: 4px 8px;\n  background: #757575;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  transition: background 0.3s;\n}\n\n.btn-delete-small:hover {\n  background: #616161;\n}\n\n@media (max-width: 768px) {\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n  \n  .backups-table {\n    font-size: 12px;\n  }\n  \n  .backup-actions-cell {\n    flex-direction: column;\n    gap: 5px;\n  }\n  \n  .pto-admin-table {\n    font-size: 12px;\n  }\n  \n  .pto-admin-table th,\n  .pto-admin-table td {\n    padding: 8px;\n  }\n}\n\n/* Send Backup Email Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content.send-email-modal {\n  background: white;\n  border-radius: 8px;\n  max-width: 440px;\n  width: 90%;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.send-email-modal .modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.send-email-modal .modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n  color: #333;\n}\n\n.send-email-modal .modal-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  line-height: 1;\n  padding: 0 4px;\n}\n\n.send-email-modal .modal-close:hover {\n  color: #333;\n}\n\n.send-email-modal .modal-body {\n  padding: 20px;\n}\n\n.send-email-modal .send-email-file-name {\n  margin: 0 0 16px;\n  font-size: 14px;\n  color: #666;\n}\n\n.send-email-modal .form-group {\n  margin-bottom: 12px;\n}\n\n.send-email-modal .form-group label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 500;\n  font-size: 14px;\n  color: #333;\n}\n\n.send-email-modal .form-group input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\n.send-email-modal .send-email-note {\n  margin: 12px 0 0;\n  font-size: 12px;\n  color: #666;\n}\n\n.send-email-modal .modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 16px 20px;\n  border-top: 1px solid #e0e0e0;\n  background: #f9f9f9;\n  border-radius: 0 0 8px 8px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
